import { render, staticRenderFns } from "./OrderNumberSection.vue?vue&type=template&id=34a8b890"
import script from "./OrderNumberSection.vue?vue&type=script&lang=js"
export * from "./OrderNumberSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports